import { getAgrimantData, getPaymantData } from 'api/api.js';
import {
  GET_AGRIMANT,
  SET_AGRIMANT,
  GET_PAYMANT,
  SET_PAYMANT,
  GET_ERRORS
} from './types';
import Swal from 'sweetalert2';

const Toast = Swal.mixin({
  toast: true,
  position: 'top-center',
  showConfirmButton: false,
  timer: 10000,
  customClass: {
    title: 'title-class'
  }
});

export const setAgrimant = data => {
  return {
    type: SET_AGRIMANT,
    payload: data
  };
};

const agrimantData = data => {
  return {
    type: GET_AGRIMANT,
    payload: data
  };
};

const paymantData = data => {
  return {
    type: GET_PAYMANT,
    payload: data
  };
};

export const setPaymant = data => {
  return {
    type: SET_PAYMANT,
    payload: data
  };
};

export const getAgriment = id => dispatch => {
  //console.log(id);
  getAgrimantData(id)
    .then(response => {
      dispatch(agrimantData(response.data));
      if (response.data.length > 0) {
        dispatch(getPaymant(response.data[0].id, 0));
      } else {
        dispatch(getPaymant(0, 0));
      }
      localStorage.setItem('agreemant', JSON.stringify(response.data));
    })
    .catch(err => {
      // Toast.fire({
      //     title: "Помилка сервера. Блок: отримання договору",
      //     type: "error"
      //   });
    });
};

export const getPaymant = (id, district) => dispatch => {
  getPaymantData(id, district)
    .then(response => {
      dispatch(paymantData(response.data));
      localStorage.setItem('paymant', JSON.stringify(response.data));
    })
    .catch(err => {
      dispatch({
        type: GET_ERRORS,
        payload: err
      });
      Toast.fire({
        title: 'Помилка сервера. Блок:отримання платежів.',
        type: 'error'
      });
    });
};
